import { AbilityBuilder, createMongoAbility } from '@casl/ability'
const { can, build } = new AbilityBuilder(createMongoAbility);

export default function defineAbilityFor(user: any) {
    if (user && user.temPermissao(['materiais'])) {
        can(['read'], 'Materiais');
        if (user.temPermissao(['admin_materiais'])) {
            can('manage', 'Materiais');
        }
        if (user.temPermissao(['materiais_obra'])) {
            can(['create_obra'], 'Materiais');
        }
        if (user.temPermissao(['materiais_projeto'])) {
            can(['create_projeto'], 'Materiais');
        }

        //RESPONSÁVEL
        can(['edit', 'liberar'], 'Materiais', {
            'Quantificou.mail': { $eq: user.email },
            'Status': {
                $in: ['REVISAR', 'EM ELABORAÇÃO']
            }
        });

        if (user.temPermissao(['editor_materiais'])) {
            can(['create', 'read'], 'Materiais');
            can(['edit', 'liberar'], 'Materiais', {
                'Status': {
                    $in: ['REVISAR', 'EM ELABORAÇÃO']
                }
            });
        }

        //VALIDADOR
        can('liberar', 'Materiais', {
            'Verificador.mail': { $eq: user.email },
            'Status': {
                $in: ['LIBERADO PARA VERIFICAÇÃO']
            }
        });

        if (user.temPermissao(['site_manager'])) {
            can('read', 'Materiais', {
                'Site_manager.mail': { $eq: user.email },
            });

            can('liberar', 'Materiais', {
                'Site_manager.mail': { $eq: user.email },
                'Status': {
                    $in: ['LIBERADO PARA SITE MANAGER']
                }
            });
        }

        // //COORDENADOR
        can('liberar', 'Materiais', {
            'Coordenador.mail': { $eq: user.email },
            'Status': {
                $in: ['LIBERADO PARA COORDENADOR']
            }
        });

        //PCP

        if (user.temPermissao(['pcp'])) {
            can('read', 'Materiais');

            can(['liberar', 'editarpcp'], 'Materiais', {
                'Status': {
                    $in: ['LIBERADO PARA PLANEJAMENTO']
                }
            });
        }

    }

    return build()
}